export default __webpack_public_path__ + "static/media/2351.750381dc.png";